import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    threads: {
        allowedExternalImgUrls: ['https://www.sparkasse.at'],
    },
    maximumAttachmentSizeLimitInMBs: 50,
    totalAttachmentsSizeLimitInMBs: 150,
    apiSupportsTypeFlag: true,
    extendedAllowedAttachmentExtensions: ['rtf', 'ppt', 'pptx'],
};
